import React from "react";
import { PreviewLoadingOverlay } from "../../components/LoadingStates";
import { cn } from "@/lib/utils";
import {
  MOBILE_BACKDROP_CLASSES,
  MOBILE_DEVICE_CLASSES,
  PageLinkActions,
  PreviewFrame,
  PreviewToolbar,
} from "../../components/PreviewPanel";
import { MOBILE_PREVIEW_WIDTH, PreviewPlayerState } from "../../components/usePreviewPlayer";

interface Props {
  preview: PreviewPlayerState;
  iframeRef: React.RefObject<HTMLIFrameElement>;
  iframeSrc: string;
  pageUrl: string;
  isSamplePreview: boolean;
  isLoading: boolean;
  previewPlayerName?: string;
}

const FullReviewsPagePreview: React.FC<Props> = ({
  preview,
  iframeRef,
  iframeSrc,
  pageUrl,
  isSamplePreview,
  isLoading,
  previewPlayerName,
}) => {
  const isMobilePreview = preview.previewDevice === "mobile";

  return (
    <div className="flex min-w-0 flex-col gap-3 lg:min-h-0 lg:flex-1">
      <PreviewToolbar preview={preview} />

      <PreviewFrame
        address={pageUrl}
        addressActions={<PageLinkActions url={pageUrl} isTemplate={isSamplePreview} />}
        className="lg:min-h-0 lg:flex-1"
      >
        <div
          className={cn(
            "relative h-[calc(100vh-18rem)] min-h-[32rem] w-full overflow-hidden lg:h-auto lg:min-h-80 lg:flex-1",
            isMobilePreview ? MOBILE_BACKDROP_CLASSES : "bg-white"
          )}
        >
          <iframe
            ref={iframeRef}
            title="Full Reviews Page preview"
            src={iframeSrc}
            className={cn(
              "mx-auto block h-full border-0 bg-white",
              isMobilePreview ? ["max-w-full", MOBILE_DEVICE_CLASSES] : "w-full"
            )}
            style={isMobilePreview ? { width: MOBILE_PREVIEW_WIDTH } : undefined}
          />
          {isLoading && <PreviewLoadingOverlay playerName={previewPlayerName} />}
        </div>
      </PreviewFrame>

      <p className="shrink-0 text-xs text-slate-500">
        Each Player's page is linked from their Embedded Highlights and the Reviews widget on their Player Card.
      </p>
    </div>
  );
};

export { FullReviewsPagePreview };
